// removed by extract-text-webpack-plugin
module.exports = {"row":"style-row-beb060dd","col":"style-col-3042cc3f","button":"style-button-3ef039fc","bannerAd":"style-bannerAd-573dd91c","rail":"style-rail-431c3943"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/style.scss
// module id = 832
// module chunks = 0